import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, XCircle } from 'lucide-react';
export function FailedSolutions() {
  const responses = ['Sí, claro… avísame. (y nunca pasa)', 'Estás exagerando.', 'Pues tú vives más cerca.', 'Yo no sé hacer eso.', '… (silencio total)'];
  return <section className="py-10 px-4 bg-cream" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-6" data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-144">
            Por qué pedir ayuda "así nomás" no funciona
          </h2>
          <p className="text-lg text-navy/80" data-id="element-145">
            Muchos cuidadores intentan esto:
            <br data-id="element-146" />
            <br data-id="element-147" />
            "¿Me pueden ayudar más?",
            <br data-id="element-148" />
            "Yo ya no puedo",
            <br data-id="element-149" />
            "Échenme la mano".
            <br data-id="element-150" />
            <br data-id="element-151" />Y la respuesta suele ser:
          </p>
        </motion.div>

        <div className="space-y-3 mb-6" data-id="element-152">
          {responses.map((response, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 p-3 bg-white rounded-lg shadow-sm border border-navy/5" data-id="element-153">
              <MessageCircle className="w-6 h-6 text-terracotta shrink-0 mt-1" data-id="element-154" />
              <p className="text-navy font-medium italic" data-id="element-155">"{response}"</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-sage/10 p-6 rounded-xl border border-sage/20" data-id="element-156">
          <div className="flex gap-4" data-id="element-157">
            <XCircle className="w-8 h-8 text-sage shrink-0" data-id="element-158" />
            <div data-id="element-159">
              <p className="text-navy/90 text-lg leading-relaxed" data-id="element-160">
                No porque tu familia sea "mala" necesariamente… sino porque{' '}
                <span className="font-bold text-navy" data-id="element-161">
                  no hay acuerdos concretos, tareas medibles, ni consecuencias
                  realistas.
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}